import { ModalSearchListener } from "../../../components/modal-search/modal-search-listener";
import type { SearchUserModalHandler } from "./search-user-modal-handler";

export interface SearchUserModalListenerParams {
    rootEl: Document | HTMLElement;
    scopeKey?: string;
    overlayEl: HTMLElement;
    modalEl: HTMLElement;
    closeBtnEl: HTMLElement | null;
    listRootEl: HTMLElement;
    filterInputEl: HTMLInputElement | null;
    handler: SearchUserModalHandler;
}

export class SearchUserModalListener {
    public static setup(params: SearchUserModalListenerParams): void {
        const {
            rootEl,
            scopeKey = "search-user-modal",
            overlayEl,
            modalEl,
            closeBtnEl,
            listRootEl,
            filterInputEl,
            handler,
        } = params;

        ModalSearchListener.setup({
            rootEl,
            scopeKey,
            overlayEl,
            modalEl,
            closeBtnEl,
            filterInputEl,
            actionRootEls: [listRootEl],
            base: handler.getBase(),
        });
    }
}
